<template>
  <NuxtLayout>
    <div class="container campMap defaultSectionMargins">
      <button type="button" class="campMap__ReturnButton" @click="returnToPreviousPage">
        <Icon name="arrow-left" />
        <span v-text="$t('back')" />
      </button> 
      <div class="campMap__ContentTop">
        <h1 v-text="page.title" />
        <p v-if="page.subtitle" v-text="page.subtitle" />

        <Button v-if="page.document && Object.keys(page.document).length" type="nuxt-link" :to="page.document.meta.url" target="_blank" rel="nofollow">{{ $t('campMap.download') }}</Button>
      </div>

      <div class="campMap__Map">
        <template v-if="page.camp_name">
          <iframe allow="fullscreen; geolocation; web-share;" frameborder="0" :src="`https://campsabout.com/map/${ page.camp_name }`" style="width: 100%; height: 850px;"></iframe>
        </template>
        <template v-else-if="page.image && Object.keys(page.image).length">
          <FlarePicture :src="{ 1920: { src: page.image, width: 1440 } }" :alt="page.image" />
        </template>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });

  const { link } = useSetup();

  async function returnToPreviousPage() {
    const windowHistory = window.history;
    if (windowHistory?.state?.back) {
      useRouter().back();
    } else {
      await navigateTo(link('Home'));
    }
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_campMap.scss');
</style>